module.exports = __webpack_public_path__ + "media/images/undraw/shift/email_campaign-4511017d9db475b8a801cd18d12bae89.png";